<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card" v-if="comp">
    <div class="table-responsive app" v-dragscroll="true">
    <table :id="rdType" class="table table-bordered fonts11 app-inner">
      <thead>
        <tr>
          <th v-for="field in columns" v-bind:key="'title'+field.title">{{field.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rawdata" v-bind:key="'td'+index">
          <td
            v-for="field in columns"
            v-bind:key="'td'+field.title+index"
            :class="(field.isNumeric)? 'text-right':''"
          >
          <span v-if="(field.title).search('date') > -1">{{getDate(row[field.title])}}</span>
          <span v-else>{{(field.isNumeric)? getFixed(row[field.title]): (row[field.title])}} </span>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>
<script>
import { commonMixins } from "../../../assets/mixins/common.js";
import { rawMixins } from "../../../assets/mixins/rawMixins.js";
export default {
  props: ["issuesData", "comp", "rdType", "columns", "rows"],
  mixins: [commonMixins, rawMixins],
  created() {},
  methods: {},
  data() {
    return {
      rawdata: []
    };
  },
  watch: {
    issuesData: function(value) {
      // console.log(this.issuesData, value);
      this.rawdata = value;
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/views/company/rawdata/sharePrices.vue